import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {MoviesObj} from 'common/src/modules/movieEditor/movieEditor.types';
import {FormatMoviesState} from './formatMovies.types';

export const formatMoviesInitialState: FormatMoviesState = {
  activeCompId: '',
  activeLayerIds: [],
  movies: {},
  isScaleLinked: true,
  movieColors: [],
  initialState: {},
  isMoviesLoading: true,
  isKeyframesGraphOn: false,
  formatsChanged: [],
  isNewImageEditorOpen: false,
};

const formatMoviesReducer = createSlice({
  name: BreadcrumbName.AdBuilder,
  initialState: formatMoviesInitialState,
  reducers: {
    resetState: () => formatMoviesInitialState,
    setInitialState: (state, action: PayloadAction<MoviesObj>) => {
      state.initialState = action.payload;
    },
    setFormatMoviesData: (
      state,
      action: PayloadAction<{
        movies: MoviesObj;
        activeCompId: string;
        activeLayerIds: string[];
        initialState: MoviesObj;
        isMoviesLoading: boolean;
      }>,
    ) => {
      state.movies = action.payload.movies;
      state.activeCompId = action.payload.activeCompId;
      state.activeLayerIds = action.payload.activeLayerIds;
      state.initialState = action.payload.initialState;
      state.isMoviesLoading = action.payload.isMoviesLoading;
    },

    updateMovies: (state, action: PayloadAction<MoviesObj>) => {
      state.movies = action.payload;
    },

    setActiveComp: (state, action: PayloadAction<string>) => {
      state.activeCompId = action.payload;
    },

    setActiveLayerIds: (state, action: PayloadAction<string[]>) => {
      state.activeLayerIds = action.payload;
    },

    setIsScaleLinked: (state, action: PayloadAction<boolean>) => {
      state.isScaleLinked = action.payload;
    },

    setMovieColors: (state, action: PayloadAction<string[]>) => {
      state.movieColors = action.payload;
    },

    setIsKeyframesGraphOn: (state, action: PayloadAction<boolean>) => {
      state.isKeyframesGraphOn = action.payload;
    },

    setFormatsChanged: (state, action: PayloadAction<string[]>) => {
      state.formatsChanged = action.payload;
    },

    setIsNewImageEditorOpen: (state, action: PayloadAction<boolean>) => {
      state.isNewImageEditorOpen = action.payload;
    },
  },
});

export const {
  resetState,
  setFormatMoviesData,
  updateMovies,
  setActiveComp,
  setActiveLayerIds,
  setIsScaleLinked,
  setMovieColors,
  setIsKeyframesGraphOn,
  setFormatsChanged,
  setIsNewImageEditorOpen,
  setInitialState,
} = formatMoviesReducer.actions;

export default formatMoviesReducer.reducer;
